import { useTranslation } from 'react-i18next';

import { GivePageShell } from '@/components/give-page-shell';
import { PoweredByFooter } from '@/components/powered-by-footer';

export const PageLoading = () => {
  const { t } = useTranslation();

  return (
    <GivePageShell footer={<PoweredByFooter />}>
      <div className="give-card page-loading" role="status" aria-live="polite">
        <div className="page-loading-spinner" aria-hidden />
        <p className="muted">{t('states.loading')}</p>
        <div className="page-loading-lines" aria-hidden>
          <span className="page-loading-line" />
          <span className="page-loading-line" />
          <span className="page-loading-line" />
        </div>
      </div>
    </GivePageShell>
  );
};

export const PageMessage = ({ message }: { message: string }) => (
  <GivePageShell footer={<PoweredByFooter />}>
    <div className="give-card give-card--centered">
      <p className="muted">{message}</p>
    </div>
  </GivePageShell>
);
